const DEFAULT_API_URL = "https://api.collarapp.uk/graphql"
const DEFAULT_RECAPTCHA_SITE_KEY = "6LcOWQMhAAAAALNGNmUAfeCSHFu9GsS5GyIbKXAC"
const CLIENT_ID = "WEB-website"

function getApiUrl() {
  return process.env.GATSBY_API_URL || DEFAULT_API_URL
}

function getRecaptchaSiteKey() {
  return process.env.GATSBY_RECAPTCHA_SITE_KEY || DEFAULT_RECAPTCHA_SITE_KEY
}

function shouldSkipRecaptcha() {
  const flag = process.env.GATSBY_DISABLE_RECAPTCHA
  return flag === "1" || flag === "true"
}

module.exports = {
  DEFAULT_API_URL,
  DEFAULT_RECAPTCHA_SITE_KEY,
  CLIENT_ID,
  getApiUrl,
  getRecaptchaSiteKey,
  shouldSkipRecaptcha,
  E2E_RECAPTCHA_TOKEN: "mock-recaptcha-token",
  RECAPTCHA_VALIDATION_ERROR:
    "Validation failed, please use a different browser or refresh the page.",
  EMAIL_PATTERN:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
}
